module.exports = __webpack_public_path__ + "img/cave5.93999aa0.jpg";